import { render, staticRenderFns } from "./TeacherSearchPage.vue?vue&type=template&id=7dec3f4a&scoped=true"
import script from "./TeacherSearchPage.vue?vue&type=script&lang=js"
export * from "./TeacherSearchPage.vue?vue&type=script&lang=js"
import style0 from "./TeacherSearchPage.vue?vue&type=style&index=0&id=7dec3f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec3f4a",
  null
  
)

export default component.exports